import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsWindsurfNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M14.546 0h2.092c.459 0 .976.162 1.358.584C18.89 1.573 21 4.601 21 11c0 3.887-.778 6.767-1.576 8.695-.207.5-.414.934-.61 1.305H24v2H5v-2h11.494a8.203 8.203 0 00.258-.409L4.814 16H2v-2h2.454L12.864.918A2 2 0 0114.546 0zm-4.16 16l7.248 2.788c.303-.755.607-1.682.85-2.788zm8.437-2c.111-.911.177-1.91.177-3h-7V9h6.921a20.959 20.959 0 00-.106-1H14V6h4.44c-.09-.36-.188-.692-.29-1H16V3h1.272a6.548 6.548 0 00-.694-1h-2.032L6.832 14z"
        fill=""
      />
    </svg>
  )
);
SvgSportsWindsurfNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsWindsurfNormalSmall;
